/* EmojiPicker.tsx generated by @compiled/babel-plugin v0.36.1 */
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
var _excluded = ["emojiProvider"];
import "./EmojiPicker.compiled.css";
import { ax, ix } from "@compiled/react/runtime";
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import React from 'react';
import { N40 } from '@atlaskit/theme/colors';
import { withAnalyticsEvents } from '@atlaskit/analytics-next';
import { ufoExperiences } from '../../util/analytics';
import LoadingEmojiComponent from '../common/LoadingEmojiComponent';
import { LoadingItem } from './EmojiPickerVirtualItems';
import { UfoErrorBoundary } from '../common/UfoErrorBoundary';
import { defaultEmojiPickerSize } from '../../util/constants';
import { EmojiCommonProvider } from '../../context/EmojiCommonProvider';
var emojiPicker = null;
var emojiPickerModuleLoader = function emojiPickerModuleLoader() {
  return import( /* webpackChunkName:"@atlaskit-internal_emojiPickerComponent" */'./EmojiPickerComponent');
};
var emojiPickerLoader = function emojiPickerLoader() {
  return emojiPickerModuleLoader().then(function (module) {
    return module.default;
  });
};
export var preloadEmojiPicker = function preloadEmojiPicker() {
  emojiPickerLoader().then(function (component) {
    EmojiPickerInternal.AsyncLoadedComponent = component;
  });
};
export var EmojiPickerInternal = /*#__PURE__*/function (_LoadingEmojiComponen) {
  function EmojiPickerInternal(props) {
    var _this;
    _classCallCheck(this, EmojiPickerInternal);
    _this = _callSuper(this, EmojiPickerInternal, [props, {}]);
    _defineProperty(_this, "state", {
      asyncLoadedComponent: EmojiPickerInternal.AsyncLoadedComponent
    });
    ufoExperiences['emoji-picker-opened'].start();
    return _this;
  }
  _inherits(EmojiPickerInternal, _LoadingEmojiComponen);
  return _createClass(EmojiPickerInternal, [{
    key: "asyncLoadComponent",
    value: function asyncLoadComponent() {
      var _this2 = this;
      emojiPickerLoader().then(function (component) {
        EmojiPickerInternal.AsyncLoadedComponent = component;
        _this2.setAsyncState(component);
      });
    }
  }, {
    key: "renderLoading",
    value: function renderLoading() {
      var _this3 = this;
      var item = new LoadingItem();
      var handlePickerRef = function handlePickerRef(ref) {
        if (_this3.props.onPickerRef) {
          _this3.props.onPickerRef(ref);
        }
      };
      ufoExperiences['emoji-picker-opened'].markFMP();
      return /*#__PURE__*/React.createElement("div", {
        ref: handlePickerRef,
        className: ax(["_19itbw7i _2rkosqtm _1e0c1txw _2lx21bp4 _1bah1yb4 _bfhk1bhr _16qsp2xt _4t3iixjv _1bsb1edt _1ul91edt _1tke5x59 _c71l1y6z"]),
        style: {
          "--_t8mjz6": ix("".concat("var(--ds-border, ".concat(N40, ")"), " 1px solid"))
        }
      }, item.renderItem());
    }
  }, {
    key: "renderLoaded",
    value: function renderLoaded(loadedEmojiProvider, EmojiPickerComponent) {
      var _this$props = this.props,
        emojiProvider = _this$props.emojiProvider,
        otherProps = _objectWithoutProperties(_this$props, _excluded);
      return /*#__PURE__*/React.createElement(UfoErrorBoundary, {
        experiences: [ufoExperiences['emoji-picker-opened']]
      }, /*#__PURE__*/React.createElement(EmojiCommonProvider, {
        emojiProvider: loadedEmojiProvider
      }, /*#__PURE__*/React.createElement(EmojiPickerComponent, otherProps)));
    }
  }]);
}(LoadingEmojiComponent);
// state initialised with static component to prevent
// rerender when the module has already been loaded
_defineProperty(EmojiPickerInternal, "defaultProps", {
  size: defaultEmojiPickerSize
});
var EmojiPicker = withAnalyticsEvents()(EmojiPickerInternal);
export default EmojiPicker;